// extracted by mini-css-extract-plugin
module.exports =  {"personal-agreement":"_93444fe79c--personal-agreement--LxRzB","dark":"_93444fe79c--dark--ct6rX","personal-agreement-link":"_93444fe79c--personal-agreement-link--kZgrX"};